import './WhyChooseUs.css';

const reasons = [
    {
        icon: '✦',
        title: 'Un accompagnement sérieux du début à la fin',
        text: "Chaque projet est étudié avec attention afin de proposer des solutions cohérentes, pratiques et adaptées à vos besoins. Nous avançons avec méthode pour garantir une rénovation fluide et bien pensée.",
    },
    {
        icon: '◆',
        title: 'Des matériaux et finitions choisis avec exigence',
        text: "Le choix des matériaux joue un rôle essentiel dans la qualité finale d’un chantier. Nous privilégions des solutions durables, esthétiques et adaptées à votre budget pour assurer un rendu à la hauteur.",
    },
    {
        icon: '●',
        title: 'Une rénovation maîtrisée et transparente',
        text: "Nous vous aidons à construire un projet réaliste, clair et cohérent. Notre approche met l’accent sur la précision, l’organisation et le respect du résultat attendu, avec une vraie attention portée aux détails.",
    },
];

export default function WhyChooseUs() {
    return (
        <section className="why-section" id="whychooseus">
            <div className="why-wrapper">
                <div className="why-left">
                    <p className="why-badge">Pourquoi choisir Kyra Renov</p>

                    <h2 className="why-title">
                        Une entreprise de rénovation
                        <span> fiable, soignée et engagée</span>
                    </h2>

                    <p className="why-description">
                        Chez <strong>Kyra Renov</strong>, nous mettons notre expertise au
                        service de vos projets de rénovation intérieure et extérieur avec une approche
                        fondée sur la qualité, l’écoute et le sens du détail. Notre objectif
                        est de créer des espaces élégants, fonctionnels et durables, en
                        apportant à chaque chantier un vrai niveau d’exigence.
                    </p>

                    <div className="why-stats">
                        <div className="why-stat-card">
                            <strong>Finitions</strong>
                            <span>propres et soignées</span>
                        </div>

                        <div className="why-stat-card">
                            <strong>Approche</strong>
                            <span>personnalisée</span>
                        </div>

                        <div className="why-stat-card">
                            <strong>Suivi</strong>
                            <span>rigoureux du projet</span>
                        </div>
                    </div>
                </div>

                <div className="why-right">
                    <div className="why-visual-card">
                        <img
                            src="/images/logo-kyra.png"
                            alt="Logo Kyra Renov"
                            className="why-img"
                        />

                        <div className="why-floating-card why-floating-top">
                            <span>Rénovation intérieure et extérieur</span>
                        </div>

                        <div className="why-floating-card why-floating-bottom">
                            <span>Qualité • Réactivité • Détail</span>
                        </div>
                    </div>

                    <div className="why-points">
                        {reasons.map((reason, index) => (
                            <div className="why-point" key={index}>
                                <div className="why-icon">{reason.icon}</div>

                                <div className="why-point-content">
                                    <h3>{reason.title}</h3>
                                    <p>{reason.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}